import { SignupEmbedderOptions } from '../SignupEmbedderOptions';
export const addQueryParam = function addQueryParam(key, value, query) {
  // Include if not a protected option.
  if (!SignupEmbedderOptions.protectedOptions.has(key)) {
    query.set(key, value);
  }
};